import React, { useState } from "react";
import "./Footer.css";
import { NavLink, Link } from "react-router-dom";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import Divider from "@mui/material/Divider";
import logo from "../../assets/logo.png";
import ComingSoon from "../../Pages/ComingSoon/ComingSoon";

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <>
      <div className="footer flex">
        <div className="footer-brand-text">
          <div>
            <Link to={"/individual"} className="flex">
              <img src={logo} alt="logo" loading="lazy" decoding="async" />
              <span style={{ color: "white" }}>Code</span>
              <span style={{ color: "var(--primarty-text-color)" }}>Queue</span>
            </Link>
          </div>
          <p className="td">The Ultimate Guide To Ace SDE Interview</p>
        </div>

        <div className="">
          <header>Quick Links</header>
          <div className="flex-col common">
            <NavLink to={"/"} className="td hover">
              Home
            </NavLink>
            <NavLink to={"/about"} className="td hover">
              About Us
            </NavLink>
            {/* <NavLink to={"/contact"} className="td hover">
              Contact
            </NavLink> */}
            <NavLink to={"/online-compiler"} className="td hover">
              Compiler
            </NavLink>
            <NavLink to={"/careers"} className="td hover">
              Careers
            </NavLink>
            {/* <NavLink to={"/codequeue-contest"} className="td hover">
              Contest
            </NavLink> */}
          </div>
        </div>

        <div className="">
          <header>Legal</header>
          <div className="flex-col common">
            <NavLink to={"/privacy-and-policy"} className="td hover">
              Privacy & Policy
            </NavLink>
            <li className="td hover" onClick={setIsVisible}>
              Term of Use
            </li>
            <NavLink to={"/refund-policy"} className="td hover">
              Refund & Cancellation Policy
            </NavLink>
          </div>
        </div>

        <div className="flex-col">
          <header>GET IN TOUCH</header>
          <div className="flex-col common">
            <li className="td hover">Support@CodeQueue.in</li>
            <div className="footer-social-media flex">
              <a
                href="https://www.linkedin.com/company/code-queue/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                className="hover"
              >
                <LinkedInIcon />
              </a>
              <a
                href="https://x.com/ssatyendrak13"
                target="_blank"
                rel="noopener noreferrer"
                className="hover"
              >
                <TwitterIcon />
              </a>
              <a
                href="https://www.instagram.com/codequeue.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover"
              >
                <InstagramIcon />
              </a>
            </div>
          </div>
        </div>
      </div>
      <Divider />
      <div className="copyright">
        {/* put the current year dynamically */}
        Copyright &copy; {new Date().getFullYear()} CodeQueue. All Rights
        Reserved.
      </div>
      <ComingSoon isVisible={isVisible} setIsVisible={setIsVisible} />
    </>
  );
};

export default Footer;
